import React from 'react';
import { Typography } from '@/lib/typography';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { tokens } from '@/lib/tokens';

// Chart tokens derived from Law
const COLORS = {
  sourced: tokens.brand.primary,   // hsl(var(--brand-900))
  reached: tokens.status.accepted.text, // Emerald (Success)
  responses: tokens.status.warning.text // Amber
};

const mockData = [
  { month: 'Apr', sourced: 12, reached_out: 20, responses: 8 },
  { month: 'May', sourced: 15, reached_out: 22, responses: 10 },
  { month: 'Jun', sourced: 18, reached_out: 25, responses: 11 },
  { month: 'Jul', sourced: 14, reached_out: 23, responses: 9 },
  { month: 'Aug', sourced: 20, reached_out: 28, responses: 12 },
  { month: 'Sep', sourced: 18, reached_out: 26, responses: 11 }
];

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload.length) {
    return (
      <div className="bg-white border border-brand-100 rounded-lg p-3 shadow-sm">
        <p className="text-brand-900 mb-2">{payload[0].payload.month}</p>
        {payload.map((entry, index) => (
          <p key={index} className="text-slate-500 flex items-center gap-2">
            <span className="w-2 h-2 rounded-full"  /* visual-law-ignore */ />
            {entry.name}: <span className="text-brand-900">{entry.value}</span>
          </p>
        ))}
      </div>
    );
  }
  return null;
};

const CustomLegend = ({ payload }) => {
  return (
    <div className="flex justify-center gap-6 mt-4">
      {payload.map((entry, index) => (
        <div key={index} className="flex items-center gap-2">
          <div
            className="w-3 h-3 rounded-full"
          /* visual-law-ignore */
          />
          <span className="text-slate-500">
            {entry.value}
          </span>
        </div>
      ))}
    </div>
  );
};

export function PipelineVelocityChart() {
  return (
    <div className="bg-white rounded-lg border border-brand-100 p-6 shadow-sm">
      <h3 className={Typography.h3}>
        Pipeline Velocity
      </h3>
      <ResponsiveContainer width="100%" height={300}>
        <LineChart data={mockData} margin={{ top: 5, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--slate-200))" /> {/* brand-100 hex */}
          <XAxis
            dataKey="month"
            stroke="hsl(var(--slate-400))"

            tickLine={false}
            axisLine={false}
          />
          <YAxis
            stroke="hsl(var(--slate-400))"

            tickLine={false}
            axisLine={false}
          />
          <Tooltip content={<CustomTooltip />} cursor={{ stroke: 'hsl(var(--slate-200))' }} />
          <Legend
            content={<CustomLegend />}
            wrapperStyle={{ paddingTop: '20px' }}
          />
          <Line
            type="monotone"
            dataKey="sourced"
            stroke={COLORS.sourced}
            strokeWidth={2}
            dot={{ fill: COLORS.sourced, r: 4, strokeWidth: 0 }}
            activeDot={{ r: 6 }}
            name="Sourced"
          />
          <Line
            type="monotone"
            dataKey="reached_out"
            stroke={COLORS.reached}
            strokeWidth={2}
            dot={{ fill: COLORS.reached, r: 4, strokeWidth: 0 }}
            activeDot={{ r: 6 }}
            name="Reached Out"
          />
          <Line
            type="monotone"
            dataKey="responses"
            stroke={COLORS.responses}
            strokeWidth={2}
            dot={{ fill: COLORS.responses, r: 4, strokeWidth: 0 }}
            activeDot={{ r: 6 }}
            name="Responses"
          />
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
}
